import { render } from "./exchange.vue?vue&type=template&id=b5f8807e&scoped=true"
import script from "./exchange.vue?vue&type=script&lang=js"
export * from "./exchange.vue?vue&type=script&lang=js"

import "./exchange.vue?vue&type=style&index=0&id=b5f8807e&scoped=true&lang=css"

import exportComponent from "/Users/cole/Desktop/중요/xz_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f8807e"]])

export default __exports__